export default __webpack_public_path__ + "static/media/cb15.3cca38d4.png";